<template>
  <div>
    <b-collapse
      class="card"
      :open="open"
    >
      <div
        slot="trigger"
        class="card-header"
        slot-scope="props"
        role="button"
      >
        <p class="card-header-title has-margin-horizontal-small">
          {{ heading }}
        </p>
        <div class="flex-pull-right is-padded-small has-margin-horizontal-small">
          <font-awesome-icon
            :icon="props.open ? 'caret-up' : 'caret-down'"
            size="2x"
          />
        </div>
      </div>
      <div
        class="card-content"
        :class="{'is-paddingless' : paddinglessContent}"
      >
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: 'Card'
    },
    open: {
      type: Boolean,
      default: false
    },
    paddinglessContent: {
      type: Boolean,
      default: false
    }
  }
}
</script>
